// src/app/modules/Devices/api.js
// Thin wrappers over the /devices API. The global axios instance already carries
// the auth token and refresh logic (redux/setupAxios.js).

import axios from 'axios';
import config from '../../../config';

const base = `${config.URL}devices`;
const dev = (deviceId) => `${base}/${encodeURIComponent(deviceId)}`;
const withOrg = (orgId, params = {}) => ({ params: { organization_id: orgId, ...params } });
const data = (p) => p.then((r) => r.data);

/** Pull the server's message out of an axios error. */
export const errorMessage = (err, fallback = 'Something went wrong') =>
  err?.response?.data?.message || err?.message || fallback;

export const devicesApi = {
  // Devices
  list: (orgId, params) => data(axios.get(base, withOrg(orgId, params))),
  get: (orgId, deviceId) => data(axios.get(dev(deviceId), withOrg(orgId))),
  update: (orgId, deviceId, body) => data(axios.patch(dev(deviceId), body, withOrg(orgId))),

  // Enrolment
  enrollableMembers: (orgId) => data(axios.get(`${base}/enrollable-members`, withOrg(orgId))),
  enableRegistration: (orgId, deviceId, membershipId) =>
    data(axios.post(`${dev(deviceId)}/registration`, { membership_id: membershipId }, withOrg(orgId))),
  registrationStatus: (orgId, deviceId) => data(axios.get(`${dev(deviceId)}/registration`, withOrg(orgId))),
  cancelRegistration: (orgId, deviceId) => data(axios.delete(`${dev(deviceId)}/registration`, withOrg(orgId))),

  // Fingerprints
  enrollments: (orgId, deviceId, params) => data(axios.get(`${dev(deviceId)}/enrollments`, withOrg(orgId, params))),
  removeEnrollment: (orgId, deviceId, enrollmentId, skipDevice = false) =>
    data(axios.delete(`${dev(deviceId)}/enrollments/${encodeURIComponent(enrollmentId)}`,
      withOrg(orgId, skipDevice ? { skip_device: true } : {}))),
  wipe: (orgId, deviceId, confirmName) => data(axios.post(`${dev(deviceId)}/wipe`, { confirm_name: confirmName }, withOrg(orgId))),

  // Commands
  commands: (orgId, deviceId, params) => data(axios.get(`${dev(deviceId)}/commands`, withOrg(orgId, params))),
  cancelCommand: (orgId, deviceId, commandId) =>
    data(axios.delete(`${dev(deviceId)}/commands/${encodeURIComponent(commandId)}`, withOrg(orgId))),

  // Scan events
  events: (orgId, params) => data(axios.get(`${base}/events`, withOrg(orgId, params))),
  resolveEvent: (orgId, eventId, body) =>
    data(axios.post(`${base}/events/${encodeURIComponent(eventId)}/resolve`, body, withOrg(orgId))),

  // Diagnostics
  traffic: (orgId, deviceId, params) => data(axios.get(`${dev(deviceId)}/traffic`, withOrg(orgId, params))),
};
